import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames/bind'

import { BodyCopy } from 'components/ui/Typography'

import s from './HeroInlineVideoSection.module.scss'
const cn = classNames.bind(s)

const HeroInlineVideoBody = ({ subtitle }) => {
  if (!subtitle?.trim?.()) return null

  return (
    <div className={cn('subtitle')}>
      <BodyCopy className={cn('subtitleInner')}>{subtitle}</BodyCopy>
    </div>
  )
}

HeroInlineVideoBody.propTypes = {
  subtitle: propTypes.string,
}

export default HeroInlineVideoBody
